import * as React from 'react'
import { Route, Switch } from 'react-router-dom'

import WizardProcessOverviewScreen from './screens/wizard/WizardProcessOverviewScreen'
import WizardReasonScreen from './screens/wizard/WizardReasonScreen'

import WizardAcutePickup from './screens/wizard/acute/PickupScreen'
import WizardAcuteLocation from './screens/wizard/acute/LocationScreen'

import WizardImpendingLocation from './screens/wizard/impending/LocationScreen'

import WizardProvisionLocation from './screens/wizard/provision/LocationScreen'
import WizardTimeFrame from './screens/wizard/provision/TimeFrameScreen'
import WizardProgress from './screens/wizard/provision/ProgressScreen'
import WizardProvisionReason from './screens/wizard/provision/ProvisionReasonScreen'
import WizardProvisionBirthYear from './screens/wizard/provision/ProvisionBirthYearScreen'

import WizardAcuteFuneralType from './screens/wizard/acute/AcuteFuneralTypeScreen'
import WizardImpendingFuneralType from './screens/wizard/impending/ImpendingFuneralTypeScreen'
import WizardProvisionFuneralType from './screens/wizard/provision/ProvisionFuneralTypeScreen'

import WizardLoadingScreen from './screens/wizard/WizardLoadingScreen'
import WizardContactScreen from './screens/wizard/WizardContactScreen'

import QuickWizardLoadingScreen from './screens/wizard/QuickWizardLoadingScreen'

import ConfiguratorScreen from './screens/ConfiguratorScreen'
import SuccessScreen from './screens/checkout/Success'
import OrderScreen from './screens/checkout/OrderScreen'
import ConfirmationScreen from './screens/checkout/Confirmation'
import SuccessProvisionScreen from './screens/checkout/SuccessProvision'
import AppointmentScreen from './screens/checkout/Appointment'
import AppointmentConfirmationScreen from './screens/checkout/AppointmentConfirmation'

import WarrantScreen from './screens/warrant/WarrantScreen'
import ThankYouScreen from './screens/warrant/ThankYouScreen'

import AdminScreen from './screens/admin/AdminScreen'

import Screen404 from './screens/Screen404'

const MainRoutes = () => (
  <main>
    <Switch>
      <Route
        exact
        path='/planung/*/detailplanung/:uuid'
        component={ConfiguratorScreen}
      />
      <Route exact path='/detailplanung/:uuid' component={ConfiguratorScreen} />
      <Route
        exact
        path='/planung/detailplanung/:uuid'
        component={ConfiguratorScreen}
      />
      <Route exact path='/planung/abschluss/:uuid' component={SuccessScreen} />
      <Route exact path='/planung/beauftragen/:uuid' component={OrderScreen} />
      <Route
        exact
        path='/planung/bestaetigung/:uuid'
        component={ConfirmationScreen}
      />
      <Route
        exact
        path='/planung/bestaetigung/:uuid'
        component={ConfirmationScreen}
      />
      <Route exact path='/planung/admin/:orderid' component={AdminScreen} />
      <Route
        exact
        path='/planung/vorsorge/bestaetigung/:uuid'
        component={SuccessProvisionScreen}
      />
      <Route
        exact
        path='/planung/vorsorge/termin/:uuid'
        component={AppointmentScreen}
      />
      <Route
        exact
        path='/planung/vorsorge/termin/bestaetigung/:uuid'
        component={AppointmentConfirmationScreen}
      />

      <Route
        exact
        path='/planung/start/(planningReason=:selected)?'
        component={WizardProcessOverviewScreen}
      />
      <Route
        exact
        path='/planung/start/(funeralType=:selected)?'
        component={WizardProcessOverviewScreen}
      />

      <Route exact path='/planung/anliegen/' component={WizardReasonScreen} />

      <Route
        exact
        path='/planung/eingetreten/ort/'
        component={WizardAcutePickup}
      />
      <Route
        exact
        path='/planung/eingetreten/plz/'
        component={WizardAcuteLocation}
      />

      <Route
        exact
        path='/planung/bevorstehend/plz/'
        component={WizardImpendingLocation}
      />

      <Route
        exact
        path='/planung/vorsorge/plz/'
        component={WizardProvisionLocation}
      />
      <Route
        exact
        path='/planung/vorsorge/planungsstand/'
        component={WizardProgress}
      />
      <Route
        exact
        path='/planung/vorsorge/zeitplan/'
        component={WizardTimeFrame}
      />
      <Route
        exact
        path='/planung/vorsorge/planungsgrund/'
        component={WizardProvisionReason}
      />
      <Route
        exact
        path='/planung/vorsorge/geburtsjahr/'
        component={WizardProvisionBirthYear}
      />

      <Route
        exact
        path='/planung/eingetreten/bestattungsart/'
        component={WizardAcuteFuneralType}
      />
      <Route
        exact
        path='/planung/bevorstehend/bestattungsart/'
        component={WizardImpendingFuneralType}
      />
      <Route
        exact
        path='/planung/vorsorge/bestattungsart/'
        component={WizardProvisionFuneralType}
      />

      <Route exact path='/planung/*/angebot/' component={WizardLoadingScreen} />

      <Route
        exact
        path='/planung/angebot/angebotserstellung/'
        component={QuickWizardLoadingScreen}
      />

      <Route
        exact
        path='/planung/*/kontakt/:uuid?'
        component={WizardContactScreen}
      />

      <Route exact path='/vollmacht/:uuid?' component={WarrantScreen} />
      <Route exact path='/clever/vollmacht/:uuid?' component={WarrantScreen} />
      <Route exact path='/danke/vollmacht/:uuid?' component={ThankYouScreen} />
      <Route exact path='/clever/danke/vollmacht/:uuid?' component={ThankYouScreen} />

      <Route component={Screen404} />
    </Switch>
  </main>
)
export default MainRoutes



// WEBPACK FOOTER //
// ./src/MainRoutes.tsx